import {Component, Input} from "@angular/core";
import {EcgSymptom} from "../../../upload/upload-model";

@Component({
    selector: "app-ecg-symptom-descriptions",
    templateUrl: "./ecg-symptom-descriptions.component.html",
    standalone: false
})
export class EcgSymptomDescriptionsComponent {

  @Input() ecgSymptoms: EcgSymptom[] = [];

}
